import React from "react";
import PropTypes from "prop-types";

export const SearchInput = React.forwardRef(({
    ariaLabel = "Search",
    className = "",
    clearLabel = "Clear",
    onClear,
    onSubmit,
    placeholder = "Search...",
    value,
    ...props
}, ref) => {
    const hasValue = String(value || "").length > 0;
    const searchClasses = [
        "hms-search",
        onClear ? "hms-search--clearable" : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <form
            className={searchClasses}
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit?.(event);
            }}
            role="search"
        >
            <i className="fas fa-search hms-search__icon" aria-hidden="true" />
            <input
                ref={ref}
                type="search"
                className="form-control hms-search__input"
                aria-label={ariaLabel}
                placeholder={placeholder}
                value={value}
                {...props}
            />
            {onClear ? (
                <button
                    type="button"
                    className="hms-search__clear"
                    disabled={!hasValue}
                    onClick={onClear}
                >
                    {clearLabel}
                </button>
            ) : null}
        </form>
    );
});

SearchInput.displayName = "SearchInput";

SearchInput.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    clearLabel: PropTypes.string,
    onClear: PropTypes.func,
    onSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
